import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';

// limit=0 makes the API return only meta.totalItems, which is all this check needs.
const CATEGORISED_TRANSACTION_TYPES_URL = `${API_URLS.TRANSACTION_TYPES}?${new URLSearchParams({
  'filter.categoryId': '$not:$null',
  limit: '0',
}).toString()}`;

export const useHasTransactionTypeCategories = () => {
  const { data, isLoading } = useQuery({
    queryKey: ['transaction-types-has-categories'],
    queryFn: () => get(CATEGORISED_TRANSACTION_TYPES_URL),
    staleTime: 60 * 1000, // 1 minute
  });

  return { hasCategories: (data?.meta?.totalItems ?? 0) > 0, isLoading };
};
